import React from "react";

const ViewEnquiry = () => {
  return <div>ViewEnquiry</div>;
};

export default ViewEnquiry;
